'use strict'

class CompanyService {
  constructor ($http, API) {
    this.$http = $http
    this.API = API + '/api/company'
  }

  getConfigByCertificate (type, validity, mediaType) {
    return this.$http({
      method: 'GET',
      url:
                this.API +
                '/type/' +
                type +
                '/validity/' +
                validity +
                '/mediaType/' +
                mediaType
    })
  }
}

angular.module('app').service('companyService', CompanyService)



//////////////////
// WEBPACK FOOTER
// ./services/company.service.js
// module id = 101
// module chunks = 0